import { ProgramProductMetadataV1NaptimeResource } from 'bundles/naptimejs/resources/__generated__/ProgramProductMetadataV1';

export default class ProgramProductMetadata extends ProgramProductMetadataV1NaptimeResource {
  static RESOURCE_NAME = 'programProductMetadata.v1' as const;
}
